import { getMessages } from '../../../../../../store/constants';

export const NOTIFICATIONS_COUNT_TOOLTIP = getMessages().getText('nav_panel.notifications_count_tooltip');
